import EventEmitter from 'events'

export class PrintEventEmitter extends EventEmitter {
  public print = (cb: any) => {
    this.emit('expand')
    cb.invoke()
  }
}
export const PrintEmitter = new PrintEventEmitter()
